import angular from 'angular';

angular.module('cloudX').directive('cxAssignmentTemplateCheckboxSelect', [
  '$q',
  '$translate',
  function($q, $translate) {
    return {
      restrict: 'E',
      template: `<div class="dropdown" uib-dropdown is-open="ddwOpen" auto-close="outsideClick" on-toggle="toggleDropDown(open)" ng-if="!disabled">
          <a href class="form-control-static" uib-dropdown-toggle ng-class="{'text-muted': !displayValue}">
            <span ng-bind="displayValue || ('AllAssignments' | translate)"></span> <span class="caret"></span>
          </a>
          <ul class="dropdown-menu" uib-dropdown-menu role="menu" style="max-height:30vh;overflow-y:auto;min-width:250px">
            <li style="padding: 3px 10px">
              <input type="text" class="form-control input-sm" ng-model="state.search" ng-model-options="{ debounce: 150 }" cx-focus-this="ddwOpen" placeholder="{{'Search' | translate}}" autocomplete="off" />
            </li>
            <li ng-repeat="item in visibleItems track by item.id" ng-class="{'divider': item.type === -1}">
              <a href ng-click="toggleItem(item)" ng-hide="item.type === -1">
                <i class="fa margin5R" ng-class="item.selected ? 'fa-check-square-o' : 'fa-square-o'"></i><span ng-bind="item.label" ng-class="{'text-muted': item.unavailable}"></span>
              </a>
            </li>
          </ul>
        </div>
        <span ng-if="disabled" ng-bind="displayValue || ('AllAssignments' | translate)"></span>`,
      scope: {
        value: '=data',
        options: '=',
        // labels by id, for templates stored on the setting but missing from the options
        labels: '=?',
        save: '&?',
        disabled: '=?',
      },
      link: function(scope, el, attrs) {
        scope.items = [];
        scope.displayValue = '';
        scope.ddwOpen = false;
        scope.visibleItems = [];
        // an object, because the ng-if around the dropdown puts ng-model on a child scope
        scope.state = { search: '' };
        const hasSaveCallback = !!attrs.save;

        // the default assignment and the divider stay visible, selected items too so they can still be unticked
        function applySearch() {
          const term = (scope.state.search || '').trim().toLowerCase();
          scope.visibleItems = scope.items.filter(
            item =>
              !term ||
              item.type === -1 ||
              item.selected ||
              (item.label || '').toLowerCase().indexOf(term) >= 0,
          );
        }

        function setDisplayValue() {
          scope.displayValue = scope.items
            .filter(x => x.selected)
            .map(x => x.label)
            .join(', ');
        }

        // a stored template that is not in the options (it no longer applies to this relation type) stays
        // visible and selected, so the row never pretends to be "all assignments"; it can only be unticked
        function unavailableItems(selected, options) {
          const labels = scope.labels || {};
          const suffix = $translate.instant('AssignmentTemplateNotApplicableToRelationType');
          return selected
            .filter(id => !options.some(x => x.id === id))
            .map(id => ({
              id,
              label: `${labels[id] || id} (${suffix})`,
              selected: true,
              unavailable: true,
            }));
        }

        function render() {
          const selected = scope.value || [];
          const options = scope.options || [];
          scope.items = [
            ...options.map(x => ({ ...x, selected: selected.indexOf(x.id) >= 0 })),
            ...unavailableItems(selected, options),
          ];
          setDisplayValue();
          applySearch();
        }

        function selectedIds() {
          return scope.items
            .filter(x => x.selected && x.type !== -1)
            .map(x => x.id)
            .sort();
        }

        scope.toggleItem = function(item) {
          item.selected = !item.selected;
          setDisplayValue();
        };

        scope.toggleDropDown = function(open) {
          if (open) return;
          scope.state.search = '';
          const newValue = selectedIds();
          if (angular.equals(newValue, (scope.value || []).slice().sort())) return;
          if (!hasSaveCallback) {
            scope.value = newValue;
            return;
          }
          $q.when(scope.save({ newValue })).then(result => {
            // the grid returns '' when the save failed, so the row keeps showing what is stored
            if (result === '') render();
          });
        };

        scope.$watch('value', render, true);
        scope.$watch('options', render);
        scope.$watch('labels', render);
        scope.$watch('state.search', applySearch);
      },
    };
  },
]);
